import ApiRequestor from "../../api_access/ApiRequestor";
import { Dispatch } from "redux";
import {
  GetLogsDispatchTypes,
  GET_LOGS_FAIL,
  GET_LOGS_LOADING,
  GET_LOGS_SUCCESS
} from './logsActionsTypes';

const buildQueryString = (params: Record<string, string | undefined>): string => {
  const query = Object.entries(params)
    .filter(([_, v]) => v !== undefined && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v!)}`)
    .join("&");
  return query ? `?${query}` : "";
};

export const GetLogs = (
  params?: {
    event_name?: string;
    event_type?: string;
    username?: string;
    service_name?: string;
  }
) => async (dispatch: Dispatch<GetLogsDispatchTypes>) => {
  try {
    dispatch({ type: GET_LOGS_LOADING });

    const queryString = params ? buildQueryString(params) : "";
    const url = `/swt-admin/logs${queryString}`;

    const response: any = await ApiRequestor.requestToApi(url, "GET");

    dispatch({
      type: GET_LOGS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({ type: GET_LOGS_FAIL });
  }
};
